<template>
        <div class="solutions-card-with-button-item">
            <div class="solutions-card-with-button-item__content">
                <img :src="data?.icon" :alt="data?.title" width="80" height="80"/>
                <div class="solutions-card-with-button-item__text">
                    <p class="solutions-card-with-button-item__title">{{ resource[data?.title] }}</p>
                    <p class="solutions-card-with-button-item__description" v-if="data?.description">{{ resource[data?.description] }}</p>
                </div>
            </div>
            <a v-if="data?.buttonUrl && data?.buttonText" :href="data?.buttonUrl" class="solutions-card-with-button-item__button">
              {{ resource[data?.buttonText] }}
            </a>
            <div class="solutions-card-with-button-item__badge" v-if="data?.useBadge && data?.badgeText">
                <span class="solutions-card-with-button-item__badge-text">{{ resource[data?.badgeText] }}</span>
            </div>
        </div>
</template>
<script>
export default {
  name: 'SolutionsCardWithButtonItem',

  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";
.solutions-card-with-button-item {
    display: flex;
    width: calc(100% / 3 - 11px);
    flex-direction: column;
    align-items: center;
    padding: 24px 24px 24px 16px;
    gap: 6px;
    border-radius: 20px;
    border: 1px solid #E4E4E4;
    background: #FFFFFF;
    position: relative;
    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      width: 100%
    }

    &__content {
        width: 100%;
        display: flex;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
        flex: 1;
    }

    &__text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        flex: 1 0 0;
    }

    &__title {
      color:#353535;
      font-family: Ubuntu;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 0;
      display: flex;
      align-items: center;
      flex: 1;
    }

    &__description {
      color:#878787;
      font-family: Ubuntu;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-bottom: 0;
      flex: 1;
    }

    &__button {
      border-radius: 50px;
      width: 214px;
      padding: 8px 22px;
      background: #FF8D06 !important;
      color: #FFFFFF;
      width: fit-content;
      min-width: fit-content;
      text-decoration: none;
      font-family: Ubuntu;
      font-size: 16px;
      font-weight: 500;
      line-height: 26px;
      letter-spacing: 0.46px;
      margin-top: 16px;
      transition: all 0.2s ease-in-out;

      &:hover{
        background: #FF7415 !important;
      }
    }

    &__badge {
      position: absolute;
      height: 20px;
      right: 37px;
      bottom: 0px;
      display: flex;
      padding: 2px 8px;
      justify-content: center;
      align-items: center;
      gap: 2px;
      border-radius: 2px 2px 0 0;
      border: 1px solid #E4E4E4;
      background: #EEEEEE;
    }

    &__badge-text {
      color: #353535;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Ubuntu;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
    }
}
</style>
